import React from "react";
import { DefaultButton } from "Shared/Components/DefaultButton/Style";
import { AdminImportStyle } from "Main/Admin/AdminImportStyle";

export const AdminImportCard = <TRow,>(props: {
    title: string;
    description: string;
    uploadButtonText: string;
    fileName?: string;
    message?: string;
    error?: string;
    emptyText: string;
    headers: string[];
    rows: TRow[];
    rowKey: (row: TRow, index: number) => string;
    renderRowCells: (row: TRow) => React.ReactNode;
    onFileImport: (event: React.ChangeEvent<HTMLInputElement>) => void;
    batchButtonText?: string;
    onBatchExecute?: () => void;
    isBatchRunning?: boolean;
    isBatchDisabled?: boolean;
    uploadingText?: string;
    controls?: React.ReactNode;
}) => {
    const fileRef = React.useRef<HTMLInputElement>(null);

    return (
        <AdminImportStyle.Card>
            <AdminImportStyle.CardTitle>{props.title}</AdminImportStyle.CardTitle>
            <AdminImportStyle.CardText>
                {props.description}
            </AdminImportStyle.CardText>

            <AdminImportStyle.UploadRow>
                <DefaultButton
                    type={"button"}
                    onClick={() => fileRef.current?.click()}
                >
                    {props.uploadButtonText}
                </DefaultButton>
                {props.onBatchExecute && (
                    <DefaultButton
                        type={"button"}
                        onClick={props.onBatchExecute}
                        disabled={props.isBatchRunning || props.isBatchDisabled}
                    >
                        {props.isBatchRunning ? (props.uploadingText ?? "Uploading...") : (props.batchButtonText ?? "Execute Batch Upload")}
                    </DefaultButton>
                )}
                {props.fileName && <AdminImportStyle.FileName>{props.fileName}</AdminImportStyle.FileName>}
            </AdminImportStyle.UploadRow>

            <AdminImportStyle.HiddenFileInput
                ref={fileRef}
                type={"file"}
                accept={".csv,text/csv"}
                onChange={props.onFileImport}
            />

            {props.error && <AdminImportStyle.Message isError>{props.error}</AdminImportStyle.Message>}
            {!props.error && <AdminImportStyle.Message>{props.message}</AdminImportStyle.Message>}
            {props.controls}

            <AdminImportStyle.TableWrap>
                <AdminImportStyle.Table>
                    <thead>
                        <tr>
                            {props.headers.map((header) => (
                                <AdminImportStyle.TableHeadCell key={header}>{header}</AdminImportStyle.TableHeadCell>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {props.rows.map((row, index) => (
                            <tr key={props.rowKey(row, index)}>
                                {props.renderRowCells(row)}
                            </tr>
                        ))}
                    </tbody>
                </AdminImportStyle.Table>
            </AdminImportStyle.TableWrap>

            {props.rows.length === 0 && (
                <AdminImportStyle.EmptyState>
                    {props.emptyText}
                </AdminImportStyle.EmptyState>
            )}
        </AdminImportStyle.Card>
    );
};
